

















































import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { Button, Uploader, Overlay } from "vant";

const createAccountModule = namespace("createAccount");
const failReasonModule = namespace("failReason");

@Component({
  name: 'FaceRecord',
  components: {
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    [Overlay.name]: Overlay
  }
})
export default class FaceRecord extends Vue {
  @createAccountModule.Getter("open_mode_info") open_mode_info: any;
  @failReasonModule.Mutation("SAVE_MODIFIED_FAIL_REASON")
  saveModifiedFailReason: any;

  showTips = false;

  handleUploadOversize() {
    this.$toast.fail("上传视频不要超过5M");
  }

  handleStartRecord(file) {
    
    
    if (file.file.size <= 0) {
      return false;
    }
    const { modify } = this.$route.query;
    //修改上传视频
    if (modify == "1") {
      this.handleUploadVideoModify(file);
    } else {
      //开户流程上传视频
      this.handleLivenessCompare(file);
    }
  }

  handleUploadVideoModify(file) {
    const params = new FormData();
    params.append("video", file.file);
    (this as any).$apis
      .uploadVideoModify(params)
      .then(() => {
        this.saveModifiedFailReason(2);
        this.$router.go(-1);
      })
      .catch(e => {
        
      });
  }

  // saveUploadVideoUrl(params) {
  //   (this as any).$apis
  //     .uploadVideoModify(params)
  //     .then(() => {
  //       return this.$router.go(-1);
  //     })
  //     .catch(e => {
  //       
  //     });
  // }

  handleLivenessCompare(file) {
    const params = new FormData();
    params.append("video", file.file);
    (this as any).$apis
      .comparePhoto(params)
      .then(res => {
        
        const { is_success, order_no } = res;
        if (is_success) {
          const params = {
            order_no,
            verify_action: 3
          };
          (this as any).$apis
            .saveFaceInfo(params)
            .then(() => {
              this.$router.push({
                path: "/personal-info-supply",
                query: {
                  ...this.$route.query,
                  open_type: "2" //常规开户
                }
              });
            })
            .catch(e => {
              
            });
          // if (this.open_mode_info.open_status == 2) {
          //
          // } else {
          //   this.$router.push({
          //     path: "/face-success",
          //     query: {
          //       ...this.$route.query,
          //       order_no,
          //       verify_action: "2"
          //     }
          //   });
          // }
        } else {
          this.$router.push({
            path: "/face-fail",
            query: {
              ["tip" as any]: this.$t("face_recognition.verify_fail_msg"),
              isTwoBtn: "1",
              order_no,
              ...this.$route.query
            }
          });
        }
      })
      .catch(e => {
        
      });
  }
}
